import { render, staticRenderFns } from "./CommonVip.vue?vue&type=template&id=11a4b902&scoped=true&"
import script from "./CommonVip.vue?vue&type=script&lang=js&"
export * from "./CommonVip.vue?vue&type=script&lang=js&"
import style0 from "./CommonVip.vue?vue&type=style&index=0&id=11a4b902&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a4b902",
  null
  
)

export default component.exports